export const KILO_BASE_2 = 1_024;
export const MEGA_BASE_2 = 1_048_576;
